import { render, staticRenderFns } from "./SewerSettings.vue?vue&type=template&id=01b7ee42&"
import script from "./SewerSettings.vue?vue&type=script&lang=js&"
export * from "./SewerSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports